"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pdf = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "pdf", { enumerable: true, get: function () { return rpdf_renderer_1.pdf; } });
//# sourceMappingURL=pdf.js.map